import React, { useContext, useEffect, useState } from "react";
import { Switch } from "antd";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Formik, Field, ErrorMessage, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getProductFeaturesHandler } from "../../redux/action/getproductFeaturesSlice";
import Loader from "../../components/Loder/loader";
import {
  handleKeyPress,
  handleKeyPressSpace,
  handlePaste,
} from "../../common/CommonFunctions";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { ThemeContext } from "../../common/themeContext";
import {
  updateProductAction,
  updateProductHandler,
} from "../../redux/action/updateProduct-Slice";
import { BrandChangeModal } from "../../components/BrandChangeModal/BrandChangeModal";
import { BreadCrum } from "../../common";
import { useCommonMessage } from "../../common/CommonMessage";
import { validationSchemaProducts } from "../../common/Validations";
import { getItem, removeItem } from "../../common/localStorage";
import { getProductFeatureNavigateUrl } from "./productNavigation";

const Editproduct = () => {
  const getAllFeaturesSelector = useSelector(
    (state) => state?.getProductFeatures
  );
  const updateProductFeatures = useSelector(
    (state) => state?.updateProductSlice
  );
  const [switchInfos, setSwitchInfos] = useState({});
  const [activeStatus, setActiveStatus] = useState(false);
  const [productData, setShowProductData] = useState();
  const [addProductFeatureModal, setAddProductFeatureModal] = useState(false);
  const { brandId } = useContext(ThemeContext);
  const messageApi = useCommonMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const product_id = getItem("productId");
  const [showClonedFromDpcp, setShowClonedFromDpcp] = useState(false); // NEW

  useEffect(() => {
    if (state?.productId || product_id) {
      let payload = {
        productId: state?.productId || product_id,
      };
      dispatch(getProductFeaturesHandler(payload));
      setShowProductData(state);
    }
  }, [state, product_id]);

  useEffect(() => {
    const newSwitchInfos = {};
    getAllFeaturesSelector?.data?.data?.productFeature?.forEach((element) => {
      if (element.status === "ACTIVE") {
        newSwitchInfos[element.id] = true;
      } else {
        newSwitchInfos[element.id] = false;
      }
    });
    setSwitchInfos(newSwitchInfos);
  }, [getAllFeaturesSelector]);

  // Switch Handler
  useEffect(() => {
    if (getAllFeaturesSelector?.data?.data?.activeStatus === "ACTIVE") {
      setActiveStatus(true);
    } else {
      setActiveStatus(false);
    }
  }, [getAllFeaturesSelector]);

  const handleSwitchChange = () => {
    setAddProductFeatureModal(true);
  };

  const handleCancel = () => {
    setAddProductFeatureModal(false);
  };

  const handleModalYes = () => {
    setAddProductFeatureModal(false);
    setActiveStatus((prevActiveStatus) => !prevActiveStatus);
  };

  const showSwitchModal = (item) => {
    setSwitchInfos((prevState) => ({
      ...prevState,
      [item?.id]: !prevState[item?.id],
    }));
    if (item?.productId && brandId) {
      let payload = {
        productId: item?.productId,
        refBrandId: brandId,
        productFeature: [
          {
            refFeatureId: item?.refFeatureId,
            GroupLevelStatusEdit: true,
            GroupLevelContentEdit: true,
            status:
              item?.status === "ACTIVE"
                ? "INACTIVE"
                : item?.status === "INACTIVE"
                ? "ACTIVE"
                : "",
          },
        ],
      };
      dispatch(updateProductHandler(payload));
    }
  };

  const getNavigateUrl = (item) => {
    getProductFeatureNavigateUrl(navigate, item, productData, {
      manageProduct: true,
    });
  };

  // Update product details
  const handleFormSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    let payload = {
      name: values?.product_name?.trim(),
      code: values?.product_code?.trim(),
      refBrandId: brandId,
      activeStatus: activeStatus === true ? "ACTIVE" : "INACTIVE",
      productId: state?.productId || product_id,
    };
    dispatch(updateProductHandler(payload));
  };

  useEffect(() => {
    if (updateProductFeatures?.data?.error === false) {
      messageApi.open({
        type: "success",
        content: updateProductFeatures?.data?.message,
      });
      let payload = {
        productId: product_id,
      };
      dispatch(getProductFeaturesHandler(payload));
      dispatch(updateProductAction.updateProductInfoReset());
    } else if (updateProductFeatures?.message) {
      messageApi.open({
        type: "error",
        content: updateProductFeatures?.message,
      });
      dispatch(updateProductAction.updateProductInfoReset());
    }
  }, [updateProductFeatures]);

  useEffect(() => {
    // Check if just cloned
    const clonedId = localStorage.getItem("productCloned");
    if ((state?.productId || product_id) && clonedId === String(state?.productId || product_id)) {
      setShowClonedFromDpcp(true);
      // Only show once, remove after first mount
      localStorage.removeItem("productCloned");
    } else {
      setShowClonedFromDpcp(false);
    }
  }, [state, product_id]);

  return (
    <>
      {(getAllFeaturesSelector?.isLoading === true ||
        updateProductFeatures?.isLoading === true) && (
          <Loader loaderTansform="loaderTansform" />
        )}
      <div className="rightside ">
        <div className="rightcontent">
          <p>
            <strong>Products</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              {
                text: BreadCrum.PRODUCTS,
                onClick: () => {
                  navigate("/product");
                  removeItem("productId");
                },
              },
              { text: BreadCrum.MANAGE_PRODUCTS, active: true },
            ]}
          />
          {/* Show the cloned label only as per our logic */}
          {showClonedFromDpcp && (
            <div className="cloned-notice">Cloned from {getItem("productClonedCode")}</div>
          )}
          <div className="login-form mx750">
            <div className="table-padding mb-30 ">
              <div className="headtitle d-block">
                <p className=" heedprodct mb-3">Manage Product</p>
                <hr />
                <Formik
                  enableReinitialize
                  initialValues={{
                    product_name:
                      getAllFeaturesSelector?.data?.data?.name || "",
                    product_code:
                      getAllFeaturesSelector?.data?.data?.code || "",
                  }}
                  validationSchema={validationSchemaProducts}
                  onSubmit={(values, formikBag) => {
                    handleFormSubmit(values, formikBag);
                  }}
                >
                  {({ isSubmitting, values, setFieldValue }) => (
                    <Form className="login-form">
                      <div className="d-xl-flex align-items-center ">
                        <div className="d-flex w-100 me-50 ">
                          <div
                            className="w-md-50 pe-md-2 mb-lg-0 mb-3 position-relative overlayinput"
                            controlId="formBasicPassword"
                          >
                            <label className="mb-2">Product Name*</label>
                            <Field
                              type="text"
                              name="product_name"
                              placeholder="Enter your product name"
                              className="form-control"
                              onKeyPress={handleKeyPressSpace}
                              // onPaste={handlePaste}
                              maxLength={30}
                            />
                            <ErrorMessage
                              name="product_name"
                              component="div"
                              className="error text-danger"
                            />
                          </div>
                          <div
                            className=" w-md-50 ps-md-2 position-relative overlayinput"
                            controlId="formBasicPassword"
                          >
                            <label className="mb-2">Product Code*</label>
                            <Field
                              type="text"
                              name="product_code"
                              placeholder="Enter your product code"
                              className="form-control"
                              onKeyPress={handleKeyPress}
                              // onPaste={handlePaste}
                              maxLength={50}
                            />
                            <ErrorMessage
                              name="product_code"
                              component="div"
                              className="error text-danger"
                            />
                          </div>
                        </div>
                        <div className="d-flex justifying">
                          <div className="mx-50 text-center">
                            <div className="productname mb-10 text-nowrap">
                              Product Status
                            </div>
                            <Switch
                              className="switches"
                              checked={activeStatus}
                              onChange={handleSwitchChange}
                            />
                          </div>
                          <div className="text-center ms-50">
                            <button className="editbuttom" type="submit">
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="grid2 mb-30">
              {getAllFeaturesSelector?.data?.data?.activeStatus === "ACTIVE" &&
                getAllFeaturesSelector?.data?.data?.productFeature?.map(
                  (item) => {
                    return (
                      <div className="optionrow">
                        <div className="option">
                          <div className="optionflex">
                            <div className="optiontext">
                              {item?.featureName}
                            </div>
                            <div className="d-flex align-items-center ">
                              <Switch
                                checked={switchInfos[item.id]}
                                className="me-3 switches"
                                onChange={() => showSwitchModal(item)}
                              />
                              <button
                                className="manage"
                                onClick={() => {
                                  getNavigateUrl(item);
                                }}
                                disabled={!switchInfos[item.id]}
                              >
                                Manage
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
          </div>
          <div className="text-end">
            <button
              type="submit"
              onClick={() => {
                navigate("/product");
                removeItem("productId");
              }}
              className="  border-0 py3 fw-18 gbo ms-auto bgtransparent  addcreatebtn"
            >
              <span>Go back to listing</span>
            </button>
          </div>
        </div>
      </div>
      {addProductFeatureModal && (
        <BrandChangeModal
          addProductFeatureModal={addProductFeatureModal}
          handleCancel={handleCancel}
          handleModalYes={handleModalYes}
          getAllFeaturesSelector={getAllFeaturesSelector}
          activeStatus={activeStatus}
        />
      )}
    </>
  );
};

export default Editproduct;
